export default __webpack_public_path__ + "static/media/in.89dde16c.svg";